import pickBy from 'lodash/pickBy';
import get from 'lodash/get';
import { replace } from 'react-router-redux';
import { SentryService } from '../../../modules/infra/observability/sentry';
import Http from '../../http';
import { redirectTo } from '../../common/helpers/routerActions';
import { HIDE_RECEIPT, SEND_RECEIPT, SEND_RECEIPT_ERROR, SEND_RECEIPT_SUCCESS, SHOW_RECEIPT } from './constants';

export const sendReceipt = ({ customerId, email, phone, transactionIdentifier }) => (dispatch) => {
  dispatch({ type: SEND_RECEIPT });
  return Http.post(`/pos/receipt/${transactionIdentifier}`, pickBy({ customerId, email, phone }))
    .then(() => {
      const type = email ? 'email' : 'phone';
      dispatch({ type: SEND_RECEIPT_SUCCESS });
      return dispatch(replace(`/customer/receipt-sent/${type}`));
    })
    .catch(() => dispatch({ type: SEND_RECEIPT_ERROR }));
};

export const redirectToReceipt = id => redirectTo(`/customer/receipt/${id}`);

const showReceiptAction = (id, total, customer, hasAppointment) => ({
  type: SHOW_RECEIPT,
  payload: {
    id,
    total,
    hasAppointment,
    phone: get(customer, 'phone'),
    email: get(customer, 'email'),
  },
});

const catchBadTransactionId = action => (id, ...rest) => {
  if (!id) {
    try {
      throw new Error('Transaction id is undefined');
    } catch (err) {
      SentryService.captureException(err);
    }
  }
  return action(id, ...rest);
};

export const showReceipt = catchBadTransactionId(showReceiptAction);

export const hideReceipt = () => ({
  type: HIDE_RECEIPT,
});
